/**
 * Per-device drawing preference for the sheet viewer's edit mode, stored in localStorage.
 *  - 'auto'   finger draws until an Apple Pencil has been seen on this device, then pencil only
 *  - 'finger' finger always draws
 *  - 'pen'    only the pencil draws; fingers scroll/zoom
 * The viewer reads it with readFingerDraw() and may listen for FINGER_DRAW_EVENT to react live.
 */
export type FingerDrawPref = 'auto' | 'finger' | 'pen';

export const FINGER_DRAW_KEY = 'kgr.fingerDraw';
export const FINGER_DRAW_EVENT = 'kgr:fingerdraw';
export const FINGER_DRAW_PREFS: readonly FingerDrawPref[] = ['auto', 'finger', 'pen'];

export function readFingerDraw(): FingerDrawPref {
  try {
    const v = localStorage.getItem(FINGER_DRAW_KEY);
    if (v === 'auto' || v === 'finger' || v === 'pen') return v;
  } catch {
    /* storage unavailable */
  }
  return 'auto';
}

export function writeFingerDraw(v: FingerDrawPref): void {
  try {
    localStorage.setItem(FINGER_DRAW_KEY, v);
  } catch {
    /* storage unavailable – preference lasts for this session only */
  }
  window.dispatchEvent(new CustomEvent<FingerDrawPref>(FINGER_DRAW_EVENT, { detail: v }));
}
